"use client";

import { create } from "zustand";

import {
  AUTH_AUDIENCES,
  type AuthAudience,
} from "@/lib/constants/auth-audiences";

const STORAGE_KEY = "nimble_last_auth_audience";

export interface LastAuthAudienceStore {
  lastAuthAudience: AuthAudience | null;
  setLastAuthAudience: (audience: AuthAudience) => void;
}

export const getInitialAuthAudience = (): AuthAudience | null => {
  if (typeof localStorage === "undefined") return null;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    if (!Object.values(AUTH_AUDIENCES).some((a) => a === stored)) return null;
    return stored as AuthAudience;
  } catch {
    return null;
  }
};

const useLastAuthAudience = create<LastAuthAudienceStore>()((set) => ({
  lastAuthAudience: getInitialAuthAudience(),
  setLastAuthAudience: (audience: AuthAudience) =>
    set({ lastAuthAudience: audience }),
}));

useLastAuthAudience.subscribe((state) => {
  if (typeof localStorage === "undefined") return;
  if (state.lastAuthAudience) {
    localStorage.setItem(STORAGE_KEY, state.lastAuthAudience);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
});

export default useLastAuthAudience;
